import React from 'react'
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from 'react-router-dom';
import { AgGridReact } from "ag-grid-react";
import { AllEnterpriseModule } from "ag-grid-enterprise";
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryBase from "../components/EntryBase";
import EntryGrid from "../components/EntryGrid";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { isEmpty, getglobaldata, initializedata, Getstorage, Savestorage, DeepCopy, getWindowDimensions, setglobaldata, getformid, getcontroller, getsubkey, isEnabled } from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist} from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, readonly} from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup} from '../modules/toolpanelstore';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

export const SMaterial = props => {

    const panelsdef = [];
    const G_id = {
        BASE: "0", IMAGE: "pic", COL: "2", SIZE: "3", SKU: "4", COMP: "5", FILE: "file"
    }
    const primarykeys = ["m_smatl_code", "m_smatl_color_key", "m_smatl_size_key", "m_smatl_sku_key", "m_smatl_comp_key"];
    const formid = getformid("SMaterial", props.location.search);
    const controller = getcontroller("SMaterial", props.location.search);
    const subkey = getsubkey(props.location.search);

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const warndescription = useSelector(state => state.form.warndiscription);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const themestyle = useSelector(state => state.form.themestyle);

    const sizedtlcolDefsInit = [{
        field: 'item', colId: 'item', headerName: "項目", lockPosition: true,
        width: 200, editable: false, filter: false, sortable: false, resizable: true
     }];
    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const apiRefcol = useRef({ grid: undefined, column: undefined });
    const apiRefsize = useRef({ grid: undefined, column: undefined });
    const apiRefsku = useRef({ grid: undefined, column: undefined });
    const apiRefcomp = useRef({ grid: undefined, column: undefined });
    const gridSizeDtlRef = useRef();    //grid api
    const locationstate = useRef(null);    //遷移State

    const menuinfo = useSelector(state => state.form.menuinfo);
    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [update, setUpdata] = useState(false);
    const [skuupdate, setskuUpdata] = useState(false);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);

    const dispatch = useDispatch();
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const search = useLocation().search;

    //データ
    const entrydataRef = useRef(null);    
    const colordataRef = useRef(null);
    const sizedataRef = useRef(null);
    const skudataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);
    const compdataRef = useRef(null);

    //列情報
    const colorcolRef = useRef(null);
    const sizecolRef = useRef(null);
    const skucolRef = useRef(null);
    const compcolRef = useRef(null);
    const coldefRefs = [
        { id: G_id.COL, ref: colorcolRef, dataref: colordataRef, api: apiRefcol.current, table: "m_smatl_color" },
        { id: G_id.SIZE, ref: sizecolRef, dataref: sizedataRef, api: apiRefsize.current, table: "m_smatl_size" },
        { id: G_id.SKU, ref: skucolRef, dataref: skudataRef, api: apiRefsku.current, table: "m_smatl_sku" },
        { id: G_id.COMP, ref: compcolRef, dataref: compdataRef, api: apiRefcomp.current, table: "m_smatl_comp" },
    ];

    function statusKey(id) {
        return formid + "entry_" + id;
    }


    const actionurl = {
        "insert": "smaterial/Insert",
         "update": "smaterial/Update",
         "delete": "smaterial/Delete",
         "saveas": "smaterial/SaveAs",
         "storageadd": "smaterial/AddStorage",
         "storagerowdel":"smaterial/StorageRowdel",
         "upload": "smaterial/Upload"
    }

    const navmenu = [
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "upload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
    ]

    function rerender() {
        setUpdata(update ? false : true);
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }

    useEffect(() => {
        if (isEmpty(skudataRef.current)) return;
        let data = AGRef.current.GetDatasource(apiRefsku.current.grid);
        if (data.length !== skudataRef.current.length) {
            apiRefsku.current.grid.setGridOption('rowData', []);
            CreateSKUData();
        }
     }, [skuupdate]);

    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey":subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    setcolumninfo(data.colinfo);
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    //列情報初期化
                    for (let i = 0; i < coldefRefs.length; i++) {
                        coldefRefs[i].ref.current = null;
                    }
                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
               }
            });
    }, [search]);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);


    useEffect(() => {
        if (formstatus === "COPY FORM") {
            entrydataRef.current["m_smatl_code"] = "";
            entrydataRef.current["m_smatl_createac"] = "";
            entrydataRef.current["m_smatl_createdate"] = "";
            entrydataRef.current["m_smatl_updateac"] = "";
            entrydataRef.current["m_smatl_update"] = "";
            rerender();
       }
    }, [formstatus]);



    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform();
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }

    function onFirstDataRendered(param,id) {
        if (id === G_id.COL) {
            apiRefcol.current.grid = param.api;
            apiRefcol.current.column = param.columnApi;
        }
        if (id === G_id.SIZE) {
            apiRefsize.current.grid = param.api;
            apiRefsize.current.column = param.columnApi;
        }
        if (id === G_id.SKU) {
            apiRefsku.current.grid = param.api;
            apiRefsku.current.column = param.columnApi;
        }
        if (id === G_id.COMP) {
            apiRefcomp.current.grid = param.api;
            apiRefcomp.current.column = param.columnApi;
        }
        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < coldefRefs.length; i++) {
                if (EmptyPanel(coldefRefs[i].id)) continue;
                if (isEmpty(coldefRefs[i].api.grid)) {
                    call = false; break;
                }
            }
            //遷移表示
            if (call) callshow();
        }
    }
    function onGridReady(param, id) {
        if (id === G_id.SKU) {
            apiRefsku.current.grid = param.api;
            apiRefsku.current.column = param.columnApi;
        }
     }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata",data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo)) return false;    //読み込み前
        clearform(code === "");
        //データ読み込み
        LoadData(code);
        return true;
    }

    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('smaterial/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                if ("m_smatl_memo" in row) data.data.m_smatl_memo = row.m_smatl_memo;
                                if ("m_smatl_sticky" in row) data.data.m_smatl_sticky = row.m_smatl_sticky;
                                if ("m_smatl_mytags" in row) data.data.m_smatl_mytags = row.m_smatl_mytags;
                            }
                        }
                        fnc.current.margeMaster(data.master);
                        entrydataRef.current = data.data;
                        //行データ
                        if (data.color.length !== 0) colordataRef.current = data.color;
                        if (data.size.length !== 0) sizedataRef.current = data.size;
                        if (data.sku.length !== 0) skudataRef.current = data.sku;
                        if (data.comp.length !== 0) compdataRef.current = data.comp;

                        fileRef.current = data.files;
                        imageRef.current = data.images;
                        dispatch(setimagelist(data.images));

                        rerender();
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
               },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }

    function existPanel(id) {
        let pnl = panel.find(e => e.id === id);
        return pnl !== undefined;
    }
    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
   }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try{
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        }catch{ }
    }
    //行データ保持
    function storeRowData(panel) {
        for (let i = 0; i < coldefRefs.length; i++) {
            if (panel === undefined || panel === coldefRefs[i].id) {
                let grid = coldefRefs[i].api.grid;
                coldefRefs[i].dataref.current = AGRef.current.GetDatasource(grid);
            }
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.COL) panelid = 'colorGrid';
        if (id === G_id.SIZE) panelid = 'sizeGrid';
        if (id === G_id.SKU) panelid = 'skuGrid';
        if (id === G_id.COMP) panelid = 'compGrid';
        if (id === G_id.FILE) panelid = 'fileGrid';
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function MenuAction(action, finallycallback, param) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            if (finallycallback.table === "m_smatl" || finallycallback.type === "100") {
                let type = "100";
                let col = textfields.find(e => e.columnid === finallycallback.field);
                if (col !== undefined) {
                    type = col.type;
                    let key = finallycallback.field + "_" + type;
                    document.getElementById(key).focus();
                    document.getElementById(key).select();
                }
                Jump(G_id.BASE, type);
                return;
            }
            let target = coldefRefs.find(e => e.table === finallycallback.table);
            if (isEmpty(target)) return;
            Jump(target.id);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, target.api.grid);
        }
        if (action === 'datatree') {
            DataTreeOpen(edittingcode);
        }
        if (action === 'listdatatree') {
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    setedittingcode(param[0][primarykeys[i]]);
                    DataTreeOpen(param[0][primarykeys[i]]);
                    return;
                }
            }
        }
        function DataTreeOpen(code) {
            fnc.current.postaxios('smaterial/GetDataTree', { "code": code },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.datatreeopen(data.list);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }

    //SKU明細カラム定義
    function ColdefSpecial(column) {
        //SKU明細color grouping
        if (column.field === "grip") {
            column.pinned = 'left';
        }
        if (column.field === "m_smatl_sku_color") {
            column.rowGroup = true;
            column.hide = true;
        }
    }

    function Save(finallycallback) {
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        storeRowData();
        const paramdata = {
            "controller": formid,
            "data": entrydataRef.current,
            "color": EmptyPanel(G_id.COL) ? null : colordataRef.current,
            "size": EmptyPanel(G_id.SIZE) ? null : sizedataRef.current,
            "sku": EmptyPanel(G_id.SKU) ? null : skudataRef.current,
            "comp": EmptyPanel(G_id.COMP) ? null : compdataRef.current,
            "images": imageRef.current,
            "files": fileRef.current,
            "colinfo": columninfo,
            "code": edittingcode
        }

        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "smaterial/UpdateEntry" : "smaterial/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            entrydataRef.current["m_smatl_code"] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        if (newfiles.length !== 0) {        //v1.4
                            //新規ファイルアップロード
                            cfFileUpload("smaterial", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            LoadData(code);     //再表示
                        }
                    }
                    else {
                        let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                        fnc.current.showwarndescription(msg, data.warning);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            "rowdata": [{ "rowid": edittingcode}]
        }
        fnc.current.postaxios("smaterial/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    //入力フィールドクリア
    function clearform(newform) {
        entrydataRef.current = initializedata(textfieldsall, staff);
        colordataRef.current = null;
        sizedataRef.current = null;
        skudataRef.current = null;
        compdataRef.current = null;
        imageRef.current = null;
        fileRef.current = null;

        scrollRef.current = null;
        if (!isEmpty(gridSizeDtlRef.current)) {
            gridSizeDtlRef.current.api.setGridOption('columnDefs', sizedtlcolDefsInit);
            gridSizeDtlRef.current.api.setGridOption('rowData', []);
        }
        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        rerender();
                    },
                }, true
            )
        }

    }
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, statusKey(G_id.BASE));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        for (let i = 0; i < coldefRefs.length; i++) {
            AGRef.current.SaveColState(statusKey(coldefRefs[i].id), EmptyPanel(coldefRefs[i].id) ? null : coldefRefs[i].column);
        }
        //基本情報保存
        Savestorage(corpkey, account, statusKey(G_id.BASE), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            switch (panel[p].id) {
                case G_id.BASE:
                    if (setbase) break;
                    let fds = textfields.filter(x => !x.hide);
                    for (let f = 0; f < fds.length; f++) {
                        coldef.push({
                            headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                            type: fds[f].type
                        });
                    }
                    setbase = true;
                    break;
                case G_id.COL:
                    cols = AGRef.current.GetshownColDef(apiRefcol.current.column);
                    break;
                case G_id.SIZE:
                    cols = AGRef.current.GetshownColDef(apiRefsize.current.column);
                    break;
                case G_id.SKU:
                    cols = AGRef.current.GetshownColDef(apiRefsku.current.column);
                    break;
                case G_id.COMP:
                    cols = AGRef.current.GetshownColDef(apiRefcomp.current.column);
                    break;
                default:
                    continue;
            }
            if (panel[p].id !== G_id.BASE) {
                for (let i = 0; i < cols.length; i++) {
                    let col = DeepCopy(cols[i]);
                    col.type = tabletype(panel[p].id);
                    coldef.push(col);
                }
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey:subkey,
                code: layoutid,
                coldef:coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    for (let i = 0; i < coldefRefs.length; i++) {
                        var type = tabletype(coldefRefs[i].id);
                        var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                        if (coldefRefs[i].length === 0) continue;
                        coldefRefs[i].ref.current = coldef;
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            //自テーブル以外編集不可
            if (tabvalue !== params.colDef.colinfo.type) return false;
        }
        return edit;
    }

    //パネル別列情報取得
    function tabletype(id) {
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }

    //Basic Data Change
    function ValueChanged(id, value) {
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }
    function ColorValueChange(param) {
        if (isEmpty(param.colDef)) return;
        if (param.colDef.field === "m_smatl_color_no") {
            CreateSKUData();
        }
        storeRowData(G_id.COL);  
    }
    function ColorChange(param) {
        CreateSKUData();
        storeRowData(G_id.COL);  
    }
    function SizeValueChange(param) {
        if (isEmpty(param.colDef)) return;
        if (param.colDef.field === "m_smatl_size_no") {
            CreateSKUData();
        }
        storeRowData(G_id.SIZE); 
    }
    function SizeChange(param) {
        CreateSKUData();
        storeRowData(G_id.SIZE);
    }
    function SizeskuValueChange(param) {
        if (isEmpty(param.colDef)) return;
        storeRowData(G_id.SIZESKU);
    }
    function CreateSKUData() {
        if (isEmpty(apiRefsku.current.grid)) return;
        let color = colorcollection();
        let size = sizecollection();
         if (color.length === 0 || size.length === 0) {
             apiRefsku.current.grid.setGridOption('rowData', []);
             skudataRef.current = null;
            return;
        }
        let data = AGRef.current.GetDatasource(apiRefsku.current.grid);
        let newdata = [];
        let idx = 0;
        for (let i = 0; i < color.length; i++) {
            for (let j = 0; j < size.length; j++) {
                let row = data.find(e => targetvalue(e, "m_smatl_sku_color") === color[i] && targetvalue(e, "m_smatl_sku_size") === size[j]);
                if (isEmpty(row)) {
                    newdata.push({ rowid:"rowid" + idx, m_smatl_sku_color: color[i], m_smatl_sku_size: size[j] });
                } else {
                    row["rowid"] = "rowid" + idx;
                    newdata.push(row);
                }
                idx++;
            }
        }
        if (JSON.stringify(skudataRef.current) === JSON.stringify(newdata)) return;
        apiRefsku.current.grid.setGridOption('rowData', newdata);
        skudataRef.current = newdata;

        function targetvalue(e, id) {
            if (isEmpty(e)) return "";
            if (id in e) {
                return e[id];
            } else {
                return "";
            }
        }
    }
    function sizecollection() {
        let size = [];
        if (isEmpty(apiRefsize.current.grid)) return size;
        apiRefsize.current.grid.forEachNode((rowNode, index) => {
            if (size.indexOf(rowNode.data.m_smatl_size_no) === -1) {
                if (!isEmpty(rowNode.data.m_smatl_size_no)) size.push(rowNode.data.m_smatl_size_no);
            }
        });
        return size;
    }
    function colorcollection() {
        let color = [];
        if (isEmpty(apiRefcol.current.grid)) return color;
        apiRefcol.current.grid.forEachNode((rowNode, index) => {
            if (color.indexOf(rowNode.data.m_smatl_color_no) === -1) {
                if (!isEmpty(rowNode.data.m_smatl_color_no)) color.push(rowNode.data.m_smatl_color_no);
            }
        });
        return color;
    }

    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };

    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock}/>
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.COL) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="colorGrid"
                    dataRef={colordataRef}
                    columnRef={colorcolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.COL)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.COL)}
                    ValueChanged={ColorValueChange}
                    RowValueChanged={ColorChange}
                    DataRowChanged={ColorChange}
                    RemoveRow={ColorChange}
                />
            );
        }
        if (props.panel.id === G_id.SIZE) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="sizeGrid"
                    dataRef={sizedataRef}
                    columnRef={sizecolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.SIZE)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.SIZE)}
                    ValueChanged={SizeValueChange}
                    RowValueChanged={SizeChange}
                    DataRowChanged={SizeChange}
                    RemoveRow={SizeChange}
                />
            );
        }
        if (props.panel.id === G_id.SKU) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="skuGrid"
                    dataRef={skudataRef}
                    columnRef={skucolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.SKU)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.SKU)}
                    AutoAddRow={false}
                    rowDragManaged={false}
                    ValueChanged={SizeskuValueChange}
                    ColdefSpecial={ColdefSpecial}
                />
            );
        }
        if (props.panel.id === G_id.COMP) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="compGrid"
                    dataRef={compdataRef}
                    columnRef={compcolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.COMP)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.COMP)}
                    ValueChanged={() => storeRowData(G_id.COMP)}
                    DataRowChanged={() => storeRowData(G_id.COMP)}
                />
            );
        }
        if (props.panel.id === G_id.FILE) {
            //v1.4
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE)  return isEmpty(textfields.find(e => e.type === type));
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if (p.id === G_id.IMAGE) {  
            if (isEmpty(imageRef.current)) return true;
            if (imageRef.current.length === 0) return true;
            return p.hide;
        }
        if (p.id === G_id.FILE) {
            if (isEmpty(fileRef.current)) return true;
            if (fileRef.current.length === 0) return true;
            return p.hide;
        }
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p,i) => {
                   return (
                        <Box
                           display={panelhidden(p) ? "none" : "flex"}
                           justifyContent="space-around"
                           alignItems="center"
                           padding="5px"
                            >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                           >
                               <div style={{ position: 'relative', marginBottom: 5 }}>
                                   {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                   {p.id !== '0' || layoutlock ? null :
                                       <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                           <IconButton size="small" onClick={()=>SetBaseField(p.type)}  >
                                               <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {layoutlock || sectionclose ? null :
                                       <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                           <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                               <Icon style={{ fontSize: 16 }}>close</Icon>
                                           </IconButton>
                                       </div>
                                   }
                               </div>
                                    <Contents panel={p}/>
                                </Paper >
                           </Box>
                    );
                })}
            </div>
        );
    }
    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primaryid={'m_smatl'}
                primarykey={primarykeys}
                navmenu={entrylock?navmenu.filter(e => e.menuid !== 'formupload'):navmenu}
                lockcell={ListlockCell}
            >
            <EntryForm/>
            </MasterBase>
            <EntryLayout
                 columninfo={textfieldsall}
                 textfields={textfields} 
                 onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={()=>fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210}}>
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.2,
                            m: 0,
                        }}
                        component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                    >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                             />
                    </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DataTree code={edittingcode} />
            <DropZone
                code={edittingcode}
                open={isDragActive}
                onclose={FileDropClose}
                actionurl={actionurl}
                uploaded={fileuploaded}
            />
        </div>
    );
};

